import { render, staticRenderFns } from "./PrevOrdersBlockForAdmin.vue?vue&type=template&id=ca3195fe&"
import script from "./PrevOrdersBlockForAdmin.vue?vue&type=script&lang=js&"
export * from "./PrevOrdersBlockForAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PrevOrdersBlockForAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports